// extracted by mini-css-extract-plugin
module.exports = {"pagination":"BlogPagination_pagination__1oAqa","active":"BlogPagination_active__3VzjW","disabled":"BlogPagination_disabled__21BA0"};